import { Base } from '@studiometa/js-toolkit';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SplitText } from 'gsap/SplitText.js';
gsap.registerPlugin(ScrollTrigger, SplitText);

/**
 * ScreenInfo component
 */
export default class ScreenPhoneIntro extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScreenPhoneIntro',
    refs: ['title'],
    options: {
      name: {
        type: String,
        default: '',
      },
      end: {
        type: String,
        default: 'bottom 300px',
      },
    },
  };

  /**
   * mounted
   */
  mounted() {
    this.initializeSplitText();
    this.animateTitle();
  }

  /**
   * Initialize SplitText for better performance
   */
  initializeSplitText() {
    this.titleElement = this.$refs.title;
    if (!this.titleElement) {
      return;
    }

    this.splitText = new SplitText(this.titleElement, { type: 'words, chars' });
    this.chars = this.splitText.chars;

    gsap.set(this.chars, { opacity: 0 });
  }

  /**
   * Create text glitch effect
   */
  createGlitchText() {
    if (!this.chars || !this.mainTimeline) {
      return;
    }

    const randomIndices = [...Array(this.chars.length).keys()].sort(() => Math.random() - 0.5);

    randomIndices.forEach((charIndex, i) => {
      const char = this.chars[charIndex];
      const delay = (i / this.chars.length) * 0.2;

      this.mainTimeline.set(this.titleElement, {
        opacity: 1,
      });

      this.mainTimeline.fromTo(
        char,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.08,
          ease: 'expo.out',
        },
        0.7 + delay,
      );
    });
  }

  /**
   * Animate the title
   */
  animateTitle() {
    this.mainTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: `#${this.$options.name}`,
        toggleActions: 'play reverse play reverse',
        end: this.$options.end,
      },
    });

    gsap.to(this.$el, {
      opacity: 1,
      zIndex: 2,
      duration: 1,
      ease: 'power4.inOut',
      scrollTrigger: {
        trigger: `#${this.$options.name}`,
        toggleActions: 'play reverse play reverse',
        end: this.$options.end,
      },
    });

    this.createGlitchText();
  }
}
